module.exports = __webpack_public_path__ + "img/typing.450c0df4.svg";